/* unplugin-vue-components disabled */import { render } from "./BaseSpeachCardBookmarkButton.vue?vue&type=template&id=06423174&scoped=true&ts=true"
import script from "./BaseSpeachCardBookmarkButton.vue?vue&type=script&lang=ts"
export * from "./BaseSpeachCardBookmarkButton.vue?vue&type=script&lang=ts"

import "./BaseSpeachCardBookmarkButton.vue?vue&type=style&index=0&id=06423174&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06423174"]])

export default __exports__